<template>
    <div class="temp-box" v-loading="loading">
        <el-input class="mb20" placeholder="请输入模版名称关键字搜索" v-model="keyword" style="width: 350px">
            <el-button slot="append" icon="el-icon-search" @click="handleSearchData"></el-button>
        </el-input>
        <div v-if="!list.length" class="no-data tac mt20">暂无数据</div>
        <TempItem 
            v-for="item in list" :key="item.id"
            :data="item"
            @use-temp="handleUseTemp"
            @del-temp="handleDelTemp"
            @top-temp="handleTopTemp"
            @default-temp="handleDefaultTemp"
            @updata-name="handleUpdataName"
            :util="util"
        />
        <div class="tac mt20 mb20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[5,10, 20,50]"
                :pager-count="5"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import TempItem from "./tempItem"
import { 
    getMaterialTempListApi, delMaterialTempApi,
    topMaterialTempApi, defaultMaterialTempApi,updateMaterialTempNameApi
} from '@/api'
export default {
    name: 'UseTempModal',
    components: { TempItem },
    props: [ 'cbs', 'defaultParams', 'util' ],
    data() {
        return {
            keyword: '',
            total: 0,
            pageNum: 1,
            pageSize: 10,
            list: [],
            loading: false
        }
    },
    created() {
        this.getList()
    },
    methods: {
        handleSearchData() {
            this.pageNum = 1;
            this.getList()
        },
        async getList() {
            try {
                this.loading = true;
                const params = { 
                    ...this.defaultParams,
                    search: this.keyword,
                    all: 0,
                    rn: this.pageSize,
                    pn: this.pageNum
                }
                const { data } = await getMaterialTempListApi(params);
                this.list = data.list;
                this.total = data.totalCnt;
            } catch (error) {
                console.log('获取模版列表失败', error);
                this.$message.error(error.info || error.message)
            }finally {
                this.loading = false;
            }
        },
       
        handleUseTemp(data) {
            this.cbs.onSubmit(data)
        },
        // 删除模版
        async handleDelTemp(data) {
            try {
                data.loading = true;
                const params = {
                    ...this.defaultParams,
                    id: data.id
                }
                await delMaterialTempApi(params);
                this.$message.success('删除成功');
                const len = this.list.length;
                if (len === 1 && this.pageNum>1) {
                    this.pageNum -=1;
                };
                this.getList();
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                data.loading = false;
            }
        },
        // 置顶
        async handleTopTemp(data) {
            try {
                data.loading = true;
                const params = {
                    ...this.defaultParams,
                    id: data.id,
                    is_top: +!+data.is_top
                }
                await topMaterialTempApi(params);
                this.getList();
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                data.loading = false;
            }
        },
        // 设置为默认
        async handleDefaultTemp(data) {
             try {
                data.loading = true;
                const params = {
                    ...this.defaultParams,
                    id: data.id,
                    is_default: +!+data.is_default
                }
                await defaultMaterialTempApi(params);
                this.getList();
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                data.loading = false;
            }
        },
        // 更新名称
        async handleUpdataName(name, data, cb) {
            const params = {
                ...this.defaultParams,
                id: data.id,
                name
            };
            try {
                data.loading = true;
                await updateMaterialTempNameApi(params);
                await this.getList()
            } catch (error) {
                this.$message.error(error.info || error.message)
            }finally {
                cb()
                data.loading = false;
            }
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.pageNum = 1;
            this.pageSize = val;
            this.getList()
        },
    }
}
</script>

<style lang="scss" scoped>
.no-data {
    color: #b6b6b6;
}
.temp-box {
    height: 100%;
    overflow: auto;
    padding: 0 20px;
}
</style>